import { useAppSelector } from "../../../../store/store";
import { MediaGridBreadCrumbs } from "./MediaGridBreadCrumbs";
import { MediaGridStandalone } from "./MediaGridStandalone";
import { MediaGridToolbar } from "./MediaGridToolbar";
import { MediaTilePanel } from "./MediaTilePanel";

function MediaGridView() {
  const viewType = useAppSelector((state) => state.media.viewType);

  if (viewType === "tile") {
    return <MediaTilePanel />;
  }

  return <MediaGridStandalone />;
}

export function MediaGrid() {
  return (
    <>
      <MediaGridToolbar />
      <div className="mt-4">
        <MediaGridBreadCrumbs />
      </div>
      <div className="mt-4">
        <MediaGridView />
      </div>
    </>
  );
}
